import { IBidderGroup } from '~/src/dash/api/bidder-group';
import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';

export interface IBidderGroupLabel {
  ID: string;
  CreatedAt: string;
  UpdatedAt?: string;
  DeletedAt?: string;
  Name: string;
  BidderGroups: IBidderGroup[];
}

// transformBidderGroupLabelFromAPI transforms an IBidderGroupLabel from the API for the UI
export const transformBidderGroupLabelFromAPI = transformModel<IBidderGroupLabel>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',
  Name: parseString(['Name']),
});
